import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { FadeInSlider } from '../../components';

const Wrapper = styled.div`
  margin-top: 50px;

  @media (max-width: 1024px) {
    margin-top: 67px;
    margin-bottom: 90px;
  }
`;

const HeaderTitle = styled.div`
  font-family: CeraStencil;
  font-size: 72px;
  font-weight: 700;
  line-height: 54px;
  letter-spacing: -3.5px;
  text-indent: 50px;

  width: 420px;
`;

const Shoutout = (props) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <FadeInSlider
        headerTitle={<HeaderTitle>LOVE THE GAME. MAKE IT YOURS.</HeaderTitle>}
        hideMobileHeader
        headerImg={require('assets/images/experience-the-sport.png')}
        headerText={[
          t('website.sportsCareer'),
          t('website.monetizeYourBrand'),
          t('website.buildAnOngoing'),
          t('website.takeControl')
        ]}
        sliderElements={[
          {
            image: require('assets/images/cheering-phone-tilted.png'),
            title: t('website.vipConnects!'),
            content: t('website.1-to-1connections')
          },
          {
            image: require('assets/images/tennis-phone-tilted.png'),
            title: t('website.connect!'),
            content: t('website.unlimitedAccess')
          },
          {
            image: require('assets/images/cheering-phone-tilted.png'),
            title: t('website.stream!'),
            content: t('website.streamGamesFrom')
          }
        ]}
      />
    </Wrapper>
  );
};

export default Shoutout;
